import { render, staticRenderFns } from "./ParonCardSection.vue?vue&type=template&id=8b2b6fdc&scoped=true"
var script = {}
import style0 from "./ParonCardSection.vue?vue&type=style&index=0&id=8b2b6fdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2b6fdc",
  null
  
)

export default component.exports